import { Directive, ElementRef } from '@angular/core';
import { ScreenUtilsService } from 'core/services';
import { Subject, map, takeUntil } from 'rxjs';

@Directive({
  selector: '[ssPageBase]',
  standalone: true,
})
export class PageBaseDirective {

  readonly #destroy = new Subject<void>()


  readonly smallScreenObs = this._screenUtilsService.screenSizeSubject.pipe(
    map((size) => size === 'sm' || size === 'xs')
  )

  constructor(
    private readonly _elementRef: ElementRef<HTMLElement>,
    private readonly _screenUtilsService: ScreenUtilsService
  ) {

  }


  ngAfterViewInit() {
    this.smallScreenObs.pipe(
      takeUntil(this.#destroy)
    )
      .subscribe((smallScreen) => {
        this._elementRef.nativeElement.classList.toggle('padding-standard', !smallScreen)

      })
  }


  ngOnDestroy() {
    this.#destroy.next()
    this.#destroy.complete()
  }
}
